import { render, staticRenderFns } from "./EipFont.vue?vue&type=template&id=044a98e5&scoped=true&"
import script from "./EipFont.vue?vue&type=script&lang=js&"
export * from "./EipFont.vue?vue&type=script&lang=js&"
import style0 from "./EipFont.vue?vue&type=style&index=0&id=044a98e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a98e5",
  null
  
)

export default component.exports